import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  typography: {
    fontFamily: ['Noto Sans', 'Arial', 'sans-serif'].join(','),
    fontSize: 14,
    fontSizeBig: 16,
    fontSizeVeryBig: 40,
    fontSizeLogo: 45,
    fontSizeSmall: 12,
    lineHeight: 1.6,
  },
  palette: {
    chart: {
      totalInspections: '#000000ff',
      pendingInspections: '#FFA500',
      completedInspections: '#4f9b7bff',
      canceledInspections: '#575757ff',
    },
    primary: {
      main: '#4f9b7bff',
      white: '#FFFFFF',
      gray: '#eeeeee',
    },
    secondary: {
      main: '#01BAEF',
    },
    logo: {
      main: '#4f9b7bff',
    },
    background: {
      default: '#F5F5F5',
    },
    link: {
      main: '#4f9b7bff',
      menu: '#000',
    },
    action: {
      hover: '#ebebeb',
      hoverDark: '#000',
      lightHover: '#f7f7f7f3'

    },
    custom: {
      darkGreen:  '#18221d',
      lightGreen: '#5f6f66',
      whiteGreen: '#dfe8e3',
      shadow: '#abb4b0'
    }
  },
  padding: {
    small: '5px',
    content: '10px',
    container: '70px',
    containerBig: '50px',
    section: '20px',
    footer: '20px',
    sideMenuButton: '138px',
  },
  radius: {
    card: '6px',
  },
  height: {
    topMenu: '60px',
    footer: '100px',
  },
  width: {
    sideMenu: '300px',
    filterDrawer: '450px',
    form: '500px',
    formMin: '300px',
    topMenuLogo: '40px',
    descriptionItem: '300px',
    limitedSpan: '200px'
  },
  shape: {
    borderRadius: 8, // Default border radius for all components
  },
  components: {
    MuiContainer: {
      styleOverrides: {
        root: {
          '&.MuiContainer-maxWidthXl': {
            maxWidth: '1250px',
          },
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
        },
        sizeMedium: {
          minHeight: '44px',
        },
        sizeLarge: {
          minHeight: '52px',
        },
        sizeSmall: {
          minHeight: '36px',
        },
      },
    },
  },
});

export default theme;
